import pagePathSegments from './pagePathSegments';

/**
 * Commonly use page paths that are also static
 */
const pagePaths = {
	AuthCallback: `/${pagePathSegments.Callback}`,
	AuthLogin: `/${pagePathSegments.Auth}/${pagePathSegments.Login}`,
	// Our logout route lives at /logout (not under /auth)
	AuthLogout: `/${pagePathSegments.Logout}`,
	AuthSilent: `/${pagePathSegments.Auth}/${pagePathSegments.Silent}`,
} as const;

export default pagePaths;
